import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from  '@angular/forms';
import { Router,ActivatedRoute } from  '@angular/router';
import { AuthenticationService } from './../../service/auth/auth.service';
import { first } from 'rxjs/operators';
import { HttpClient  } from '@angular/common/http';


@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {
  loginForm: FormGroup;
  isSubmitted  =  false;
  isValid =  false;
  ipAddress:any='';
  loader:boolean=true;
  return_url:string;
  Year:any;
  constructor(
    private router: Router,
    public formBuilder: FormBuilder,
    private service:AuthenticationService,
    private http:HttpClient,
    private route:ActivatedRoute
  ) {
    if (this.service.currentUserValue) {
      this.router.navigate(['/parking-rate']);
    }
    this.route.queryParams.subscribe(params => {
      this.return_url=params.returnUrl;
      console.log(this.return_url);

     });
    this.getIPAddress();
    this.Year=new Date().getFullYear();

  }

  ngOnInit(): void {
    this.loginForm  =  this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      ipaddress: [this.ipAddress],

  });

  }
  ngAfterContentInit() {
    this.loader=false;
  }
  getIPAddress()

  {

    this.http.get("https://api.ipify.org/?format=json").subscribe((res:any)=>{

      this.ipAddress = res.ip;

    });

  }
  get formControls() { return this.loginForm.controls; }

  loginSubmit(){
    this.isSubmitted = true;
    this.isValid=true;
    this.loader=true;
    if(this.loginForm.valid){
      this.loginForm.get('ipaddress').setValue(this.ipAddress);
       this.service.login(this.loginForm.value).pipe(first())
       .subscribe(
           (data:any) => {
             if(this.return_url){
              this.router.navigateByUrl(this.return_url);

             }else{
              this.router.navigate(['parking-rate']);
             }

               this.loader=false;
           },
           error => {
            this.isSubmitted = false;
            this.loader=false;
           });


    }else{
      this.isSubmitted = false;
      this.loader=false;
    }

  }

}
